import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaGlobeAfrica } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logounite2.png";
import "./public-nav.css";

const languageLabels = {
  en: "English",
  fr: "Français",
};

const NavBar = ({ activePage = "home" }) => {
  const { t, i18n } = useTranslation();
  const [languageOpen, setLanguageOpen] = useState(false);
  const currentLanguage =
    languageLabels[i18n.language] || languageLabels.en;

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setLanguageOpen(false);
  };

  return (
    <header className="public-nav">
      <Link
        to="/getstarted"
        className="public-nav-brand"
        aria-label="BioEnroll home"
      >
        <img src={logo} alt="BioEnroll" />
        <span className="public-nav-divider" />
        <span className="public-nav-title">
          <strong>{t("citizen_preenrollment")}</strong>
          <small>{t("secure_identity_access")}</small>
        </span>
      </Link>
      <nav className="public-nav-links" aria-label="Primary navigation">
        <Link
          className={activePage === "home" ? "active" : ""}
          to="/getstarted"
        >
          {t("home")}
        </Link>
        <Link className={activePage === "help" ? "active" : ""} to="/help">
          {t("help")}
        </Link>
        <div className="public-nav-language">
          <button
            type="button"
            onClick={() => setLanguageOpen(!languageOpen)}
            aria-expanded={languageOpen}
          >
            <FaGlobeAfrica aria-hidden="true" /> {currentLanguage}{" "}
            <FaChevronDown aria-hidden="true" />
          </button>
          {languageOpen && (
            <div className="public-nav-language-options">
              {Object.entries(languageLabels).map(([language, label]) => (
                <button
                  type="button"
                  key={language}
                  onClick={() => changeLanguage(language)}
                >
                  {label}
                </button>
              ))}
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default NavBar;
